module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: (_vm.participantSingularName + " Dashboard"),
        link: 'Dashboard Participant',
        id: _vm.$route.params.id
      }, {
        name: 'Assessment and Outcomes'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 db-column",
    attrs: {
      "id": "first-column"
    }
  }, [_c('profile-participant')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 db-column",
    attrs: {
      "id": "second-column"
    }
  }, [_c('assingment')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form-crud', {
    attrs: {
      "type": "assessment_outcomes",
      "sortByName": true
    },
    on: {
      "refresh-communication-notes": function($event) {
        return _vm.loadParticipant(_vm.$route.params.id)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "third-column"
    }
  }, [_c('case-notes')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28eb14a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AssessmentAndOutcomes.vue
// module id = 1587
// module chunks = 1